import { Layout } from 'antd';
import { Avatar } from 'antd';
import styled from 'styled-components';

const { Header } = Layout;

export const StyledHeader = styled(Header)`
  width: 100%;
  height: 53px;
  border: solid 1px rgba(215, 214, 217, 1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  padding: 0px 20px;
  z-index: 1000;
  ${({ theme }) =>
    theme.media.monitor(
      `
        height: 65px;
        padding: 0px 30px;
    	`,
    )}
`;

export const MenuBlock = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 0.7vw;
  cursor: pointer;
  p {
    font-family: 'Suit bold', 'Inter bold';
    font-size: 10px;
    font-weight: 700;
    line-height: 22px;
    color: rgba(151, 151, 153, 1);
    @media screen and (min-width: 300px) and (max-width: 1000px) {
      font-size: 8px;
    };
    ${({ theme }) =>
    theme.media.monitor(
      `
        font-size: 12px;
    	`,
    )}
  }
`;

export const Logo = styled.img`
  width: 30px;
  height: auto;

  :hover {
    cursor: pointer;
  }
`;

export const UserInfo = styled.div`
  cursor: pointer; 
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  height: 70%;
  border-radius: 10px;
  font-weight: 400;
  color: rgba(38, 38, 38, 1);
  white-space: nowrap;
  font-size: 14px;
  line-height: 22px;
  font-family: 'Suit bold', 'Inter bold';

  :hover {
    cursor: pointer;
  }
  
  ${({ theme }) =>
    theme.media.monitor(
      `
        font-size: 16px;
    	`,
    )}
`;

export const AvatarStyle = styled(Avatar)`
    color: rgb(238, 237, 240);
    font-size: 27px;
    text-align: end;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    font-size: 30px;
`;